import {api} from 'app/services/api';
import {changeHeaderText} from 'app/actions/headerActions';
import {catchDataError} from 'app/helpers/apiHelpers';
import {updateHistory} from 'app/actions/historyActions';
import {updateHttpError} from 'app/components/error/ErrorHandlerActions';

const getClubContactPerson = contactSlug => {
  return api.get(`/contacts/${contactSlug}`);
};

function updateContactDetail(data) {
  return {
    type: 'CLUB_CONTACT_DETAIL_UPDATE',
    data,
  };
}

function fetchingContactDetail() {
  return {
    type: 'CLUB_CONTACT_DETAIL_FETCHING',
  };
}

function setClubContactDetailHeader(dispatch, contact) {
  const parent = {
    name: contact.club.name,
    entity: 'club',
    slugs: {
      clubSlug: contact.club.slug,
    },
  };

  dispatch(
    changeHeaderText({
      title: contact.name,
      parent,
    })
  );
}

function fetchClubContactDetailSSR(slug) {
  return async function (dispatch) {
    try {
      const response = await getClubContactPerson(slug);
      dispatch(
        updateHistory('undefined', {
          store: 'ClubContactDetailPage',
          data: {contact: response.data, isFetching: false, error: null},
        })
      );
      setClubContactDetailHeader(dispatch, response.data);
    } catch (error) {
      const errorData = catchDataError(error);
      dispatch(updateHttpError(errorData));
    }
  };
}

function fetchClubContactDetail(slug, dispatchRedux) {
  return function (dispatch, state) {
    if (Object.keys(state.contact).length) {
      setClubContactDetailHeader(dispatchRedux, state.contact);
      return;
    }
    dispatch(fetchingContactDetail());
    return getClubContactPerson(slug)
      .then(response => {
        dispatch(updateContactDetail(response.data));
        setClubContactDetailHeader(dispatchRedux, response.data);
      })
      .catch(error => {
        const errorData = catchDataError(error);
        dispatchRedux(updateHttpError(errorData));
      });
  };
}

export {fetchClubContactDetailSSR, fetchClubContactDetail};
